import { DocumentType, InvoiceDocumentNumberType } from '../Interfaces/Draft/DraftInterface'
import * as api from './apiHelper'

export interface InvoicenumberResponseInterface {
  invoicenumber: number | boolean
}

export interface ReceiptNumberResponseInterface {
  number: string
}

export interface DeliverynoteNumberResponseInterface {
  number: string
}

export async function getNextNumber(type: DocumentType): Promise<InvoicenumberResponseInterface> {
  const response = await api.Get(`/rest-invoice/api/${type}s/number/next`)
  return Promise.resolve(response)
}

export async function getNextNumberV1<T>(type: DocumentType): Promise<T> {
  const response = await api.Get(`/rest-invoice/api/v1/${type}s/number/next`)
  return Promise.resolve(response)
}

export async function getDocumentNumberSequences(type: DocumentType): Promise<InvoiceDocumentNumberType[]> {
  const response = await api.Get(`/rest-invoice/api/${type}s/number`)
  return Promise.resolve(response)
}

export async function createDocumentNumberSequence(
  type: DocumentType,
  newSequence: InvoiceDocumentNumberType,
): Promise<InvoiceDocumentNumberType> {
  const response = await api.Post(`/rest-invoice/api/${type}s/number`, newSequence)
  return Promise.resolve(response)
}
